import React from 'react';
import { Button } from 'antd';
import { TranslationOutlined } from '@ant-design/icons';

export default function TranslateButton({
  onClick,
  loading,
  disabled,
  size,
  children = 'Prevedi automatski',
}) {
  return (
    <Button
      icon={<TranslationOutlined />}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      type="default"
      size={size}
    >
      {children}
    </Button>
  );
}
